import { FC } from 'react';
import {
  Card,
  Checkbox,
  Input,
  InputError,
  Label,
  Textarea,
} from '@features/ui';
import { Controller } from 'react-hook-form';

interface UserDetailsProps {
  method: any;
}
export const UserDetails: FC<UserDetailsProps> = ({ method }) => {
  const {
    control,
    formState: { errors },
  } = method;

  return (
    <>
      <Card className={'text-xs pb-20'}>
        <div className="w-full lg:max-w-[361px]">
          <Controller
            control={control}
            name="username"
            render={({ field }) => (
              <div className="flex flex-col gap-y-2.5 mb-5">
                <Label htmlFor={field.name} size={'xs'}>
                  User Name
                </Label>
                <div>
                  <Input
                    {...field}
                    autoComplete="new-username"
                    error={!!errors.username}
                    id={field.name}
                    placeholder={'Username'}
                    textSize={'xs'}
                  />
                  {errors.username?.message && (
                    <InputError>{errors.username?.message}</InputError>
                  )}
                </div>
              </div>
            )}
          />
          <Controller
            control={control}
            name="password"
            render={({ field }) => (
              <div className="flex flex-col gap-y-2.5 mb-5">
                <Label htmlFor={field.name} size={'xs'}>
                  Password
                </Label>
                <div>
                  <Input
                    {...field}
                    autoComplete="new-password"
                    error={!!errors.password}
                    id={field.name}
                    placeholder={'Password'}
                    textSize={'xs'}
                    type="password"
                  />
                  {errors.password?.message && (
                    <InputError>{errors.password?.message}</InputError>
                  )}
                </div>
              </div>
            )}
          />
          <Controller
            control={control}
            name="fullname"
            render={({ field }) => (
              <div className="flex flex-col gap-y-2.5 mb-5">
                <Label htmlFor={field.name} size={'xs'}>
                  Full Name
                </Label>
                <div>
                  <Input
                    {...field}
                    error={!!errors.fullname}
                    id={field.name}
                    placeholder={'Full Name'}
                    textSize={'xs'}
                  />
                  {errors.fullname?.message && (
                    <InputError>{errors.fullname?.message}</InputError>
                  )}
                </div>
              </div>
            )}
          />
          <Controller
            control={control}
            name="email"
            render={({ field }) => (
              <div className="flex flex-col gap-y-2.5 mb-5">
                <Label htmlFor={field.name} size={'xs'}>
                  Email
                </Label>
                <div>
                  <Input
                    {...field}
                    error={!!errors.email}
                    id={field.name}
                    placeholder={'johndoe@gmail.com'}
                    textSize={'xs'}
                  />
                  {errors.email?.message && (
                    <InputError>{errors.email?.message}</InputError>
                  )}
                </div>
              </div>
            )}
          />
          <Controller
            control={control}
            name="account_active"
            render={({ field }) => (
              <div className={'mt-11'}>
                <Checkbox
                  checked={field.value}
                  label={'Account Active?'}
                  onCheckedChange={(checked) => field.onChange(checked)}
                />
              </div>
            )}
          />
        </div>
        <Controller
          control={control}
          name="notes"
          render={({ field }) => (
            <div className={'mt-8'}>
              <Label className={'mb-3'} htmlFor={field.name} size={'xs'}>
                Notes
              </Label>
              <Textarea
                {...field}
                className={'h-42 pt-8'}
                id={field.name}
                placeholder={'Same editor as email template will be used here'}
              />
            </div>
          )}
        />
      </Card>
    </>
  );
};
